var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordImgRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "password_img_red",
    clipPath: "url(#clip0_2249_336)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.168 19.8333V17.5C29.168 16.8811 28.9221 16.2876 28.4846 15.85C28.047 15.4125 27.4535 15.1666 26.8346 15.1666H3.5013C2.88246 15.1666 2.28897 15.4125 1.85139 15.85C1.4138 16.2876 1.16797 16.8811 1.16797 17.5V31.5C1.16797 32.1188 1.4138 32.7123 1.85139 33.1499C2.28897 33.5875 2.88246 33.8333 3.5013 33.8333H26.8346C27.4535 33.8333 28.047 33.5875 28.4846 33.1499C28.9221 32.7123 29.168 32.1188 29.168 31.5V29.1666M29.168 19.8333H19.8346C18.597 19.8333 17.41 20.325 16.5348 21.2001C15.6596 22.0753 15.168 23.2623 15.168 24.5C15.168 25.7376 15.6596 26.9246 16.5348 27.7998C17.41 28.675 18.597 29.1666 19.8346 29.1666H29.168M29.168 19.8333C30.4056 19.8333 31.5926 20.325 32.4678 21.2001C33.343 22.0753 33.8346 23.2623 33.8346 24.5C33.8346 25.7376 33.343 26.9246 32.4678 27.7998C31.5926 28.675 30.4056 29.1666 29.168 29.1666M8.16797 15.1666V8.16663C8.16797 6.31011 8.90547 4.52963 10.2182 3.21688C11.531 1.90412 13.3115 1.16663 15.168 1.16663C17.0245 1.16663 18.805 1.90412 20.1177 3.21688C21.4305 4.52963 22.168 6.31011 22.168 8.16663V15.1666M28.0013 24.5H30.3346M23.3346 24.5H25.668M18.668 24.5H21.0013",
    stroke: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2249_336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordImgRed);
export default __webpack_public_path__ + "static/media/password_img_red.9fb421bb4596c38ddb934cadb19ce693.svg";
export { ForwardRef as ReactComponent };